// Imports: local files.
import {
  GET_PRODUCTS_START,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_FAILED,
  GET_PRODUCTS_RESET,
  GET_PRODUCT_START,
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_FAILED,
  GET_PRODUCT_RESET,
  CREATE_PRODUCT_START,
  CREATE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_FAILED,
  CREATE_PRODUCT_RESET,
  UPDATE_PRODUCT_START,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAILED,
  UPDATE_PRODUCT_RESET,
  DELETE_PRODUCT_START,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAILED,
  DELETE_PRODUCT_RESET,
} from '../actions';

const initialLoadingState = {
  loading: false,
  success: false,
  data: null,
  error: false,
  errorMessage: null,
};
const initialState = {
  getAll: initialLoadingState,
  getOne: initialLoadingState,
  create: initialLoadingState,
  updateOne: initialLoadingState,
  deleteOne: initialLoadingState,
};

const productsReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * =======================================================================
     * Get All Products
     * =======================================================================
     */
    case GET_PRODUCTS_START:
      return { ...state, getAll: { ...action.payload } };
    case GET_PRODUCTS_SUCCESS:
      return { ...state, getAll: { ...action.payload } };
    case GET_PRODUCTS_FAILED:
      return { ...state, getAll: { ...action.payload } };
    case GET_PRODUCTS_RESET:
      return { ...state, getAll: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Get One Product
     * =======================================================================
     */
    case GET_PRODUCT_START:
      return { ...state, getOne: { ...action.payload } };
    case GET_PRODUCT_SUCCESS:
      return { ...state, getOne: { ...action.payload } };
    case GET_PRODUCT_FAILED:
      return { ...state, getOne: { ...action.payload } };
    case GET_PRODUCT_RESET:
      return { ...state, getOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Create Product
     * =======================================================================
     */
    case CREATE_PRODUCT_START:
      return { ...state, create: { ...action.payload } };
    case CREATE_PRODUCT_SUCCESS:
      return { ...state, create: { ...action.payload } };
    case CREATE_PRODUCT_FAILED:
      return { ...state, create: { ...action.payload } };
    case CREATE_PRODUCT_RESET:
      return { ...state, create: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Update One Product
     * =======================================================================
     */
    case UPDATE_PRODUCT_START:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_PRODUCT_SUCCESS:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_PRODUCT_FAILED:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_PRODUCT_RESET:
      return { ...state, updateOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Delete One Product
     * =======================================================================
     */
    case DELETE_PRODUCT_START:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_PRODUCT_SUCCESS:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_PRODUCT_FAILED:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_PRODUCT_RESET:
      return { ...state, deleteOne: { ...initialLoadingState } };
    default:
      return state;
  }
};

export default productsReducer;
